<template>
  <div class="company-login">
    <div class="login-main">
      <img src="@/assets/register/logo.png" alt="" @click="back" class="logo">
      <div class="center">
        <div class="login-head">
          <ul class="tab-hd">
            <router-link
              tag="li"
              active-class="on"
              v-for="(item,index) in tabHd" 
              :key="index"
              :to="item.path"
              replace
            >{{item.text}}</router-link>
            <!-- <li v-for="(item,index) in tabHd" :key="index" :class="{on:tabId==item.id}" @click="tabChange(item.id)">{{item.text}}</li> -->
          </ul>
          <span class="btn-reg" @click="$router.push('/register')">注册企业账号&gt;&gt;</span>
        </div>
        <div class="form" v-show="tabId==1">
          <div class="form-item">
            <input class="input" v-model.trim="loginName" type="text" placeholder="企业登录账号">
          </div>
          <div class="form-item">
            <input class="input" v-model.trim="password" type="password" @keydown.enter="login" placeholder="请输入您的密码">
          </div>
        </div>
        <div class="form" v-show="tabId==2">
          <div class="form-item">
            <input class="input" v-model.trim="phone" type="text" placeholder="请输入注册时填写手机号">
          </div>
          <div id="captcha"></div>
          <div class="form-item code-item">
            <input class="input" v-model.trim="code" type="text" placeholder="请输入验证码">
            <button class="btn-code" :disabled="btnDisabled" @click="getCode">{{codeBtnText}}</button>
          </div>
        </div>
        <div class="form-foot">
          <el-checkbox v-model="isRemember" v-show="tabId==1">记住用户名</el-checkbox>
          <span class="btn-forget" v-if="tabId==1"  @click="$router.push({path:'/resetPassword',query:{type:2}})">忘记密码?</span>
        </div>
        <div class="btn-primary" @click="login">登录</div>
        <div class="btn-group">
          <span class="btn-type" v-if="tabId==1" @click="tabChange(2)">验证码登录</span>
          <span class="btn-type" v-else @click="tabChange(1)">账号密码登录</span>
        </div>
      </div>
    </div>
    <gk-footer></gk-footer>
  </div>
</template>

<script>
import validate from '@/scripts/validate.js'
import {aesEncrypt} from '@/scripts/aesHelper.js'
import gkFooter from '@/components/footer.vue'
import { bpoLoading, bpoHideLoading } from '@/scripts/bpo.js';
import {
  CompanyLogin,
  CompanyMobileLogin,
  SendValidCode,
  SendMobileCode,
} from '@/scripts/api.js';
let _dx=window._dx;
export default {
  name: 'personLogin',
  components:{
    gkFooter
  },
  data(){
    return{
      tabHd:[{
        text:'企业登录',
        path:'/companyLogin',
        id:2,
      },{
        text:'个人登录',
        path:'/personLogin',
        id:1,
      }],
      isRemember:false,
      tabId:1,
      loginName:'',
      password:'',
      phone:'',
      code:'',
      codeBtnText: "获取验证码",
      btnDisabled: false,
      timer: null,
      imgCodeToken:'',
    }
  },
  created() {
    let account=this.$getStorage('companyAccount');
    if(account){
      account=JSON.parse(account);
    }
    if(account && account.isRemember){
      this.isRemember = account.isRemember;
      this.loginName = account.loginName;
      this.password = account.password;
    }
  },
  methods: {
    //回到首页
    back(){
      this.$router.replace('/');
    },
    //切换登录方式
    tabChange(id){
      this.tabId=id;
    },
    //获取验证码
    getCode() {
      var that = this;
      if (this.phone === "") {
        this.$toast("请输入手机号！");
        return;
      }
      if (
        this.phone !== "" &&
        !validate.phone(this.phone)
      ) {
        this.$toast("手机号格式不正确");
        return;
      }
      var myCaptcha = _dx.Captcha(document.getElementById('captcha'), {
          appId: 'e8941fd8bdcac157c64dedb50d13d1f7', //appId，在控制台中“应用管理”或“应用配置”模块获取
          style: 'inline',
          width: 400,
          success: function (token) {
            SendMobileCode({
              phone: that.phone,
              codeType: 108,
              imgCodeToken:token,
              platform:'pcweb'
            }).then(r => {
              // myCaptcha.hide();
              if (r.Result == 1) {
                let time = 120;
                that.btnDisabled = true;
                that.timer = setInterval(() => {
                  time--;
                  that.codeBtnText = time + "s";
                  if (time <= 0) {
                    time = 120;
                    that.btnDisabled = false;
                    that.codeBtnText = "获取验证码";
                    clearInterval(that.timer);
                  }
                }, 1000);
                that.$toast(r.Message);
              } else {
                that.$toast(r.Message);
              }
            });
          },
          fail:function(err){
            console.log(err)
          }
      })
      myCaptcha.show();
      // SendValidCode({
      //   phone:this.phone,
      //   codeType:108,
      // }).then(r => {
      //   // myCaptcha.hide();
      //   if (r.Result == 1) {
      //     let time = 120;
      //     that.btnDisabled = true;
      //     that.timer = setInterval(() => {
      //       time--;
      //       that.codeBtnText = time + "s";
      //       if (time <= 0) {
      //         time = 120;
      //         that.btnDisabled = false;
      //         that.codeBtnText = "获取验证码";
      //         clearInterval(that.timer);
      //       }
      //     }, 1000);
      //     that.$toast(r.Message);
      //   } else {
      //     that.$toast(r.Message);
      //   }
      // });
    },
    login(){
      if(this.tabId==1){
        this.passwordLogin();
      }else{
        this.codeLogin();
      }
    },
    //验证码登录
    codeLogin(){
      if (this.phone === "") {
        this.$toast("请输入手机号！");
        return;
      }
      if (
        this.phone !== "" &&
        !validate.phone(this.phone)
      ) {
        this.$toast("手机号格式不正确");
        return;
      }
      if(this.code==''){
        this.$toast('请输入验证码')
        return;
      }
      CompanyMobileLogin({
        AppId: 200101,
        Handset: this.phone,
        ValidateCode: this.code,
        ValidateCodeType: 108
      }).then(async r=>{
        if(r.Result==1){
          this.$toast(r.Message);
          //储存用户信息，并获取用户权限
          let data=r.Data;
          data['LoginAccountType']=2;
          data['LoginAccountId']=data.companyId;
          this.$store.commit('setUserInfo',data);

          var loadingLayer = bpoLoading(); 
          await this.$store.dispatch('loadAccountData',true); 
          await this.$store.dispatch('loadPermission',true);
          bpoHideLoading(loadingLayer);

          this.$router.replace('/home');
          // this.$router.go(-1);
        }else{
          this.$toast(r.Message);
        }
      })
    },
    //密码登录
    passwordLogin(){
      if(this.loginName==''){
        this.$toast('请输入用户名/手机号')
        return;
      }
      if(this.password==''){
        this.$toast('请输入登录密码')
        return;
      }
      CompanyLogin({
        loginName:this.loginName,
        password:aesEncrypt(this.password,2),
        AppId:101001,
      }).then(async r=>{
        if(r.Result==1){
          this.$toast(r.Message);
          if(this.isRemember){
            this.$setStorage('companyAccount',{
              isRemember: this.isRemember,
              loginName:this.loginName,
              password: this.password
            })
          }else{
            this.$removeStorage('companyAccount')
          }
          //储存用户信息，并获取用户权限
          let data=r.Data;
          data['LoginAccountType']=2;
          data['LoginAccountId']=data.companyId;

          console.log("登录");
          this.$store.commit('setUserInfo',data);
          await this.$store.dispatch('loadAccountData',true);
          await this.$store.dispatch('loadPermission',true);
          this.$router.replace('/home');
          // this.$router.go(-1);
        }else{
          this.$toast(r.Message);
        }
      })
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
}
</script>

<style lang="scss">
.company-login{
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  padding-top: 68px;
  background: url('~@/assets/register/bg.png') no-repeat center top;
  background-size: cover;
  .login-main{
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 2;
    margin-left: -260px;
    margin-top: -400px;
    .logo{
      display: block;
      width: 203px;
      height: 42px;
      margin: 0 auto 26px;
    }
    .center{
      width: 520px;
      height: 600px;
      margin: 0 auto;
      padding: 30px 60px;
      background-color: #fff;
      position: relative;
      border-radius: 10px;
      box-shadow: 0px 2px 20px 0px rgba(34, 23, 20, 0.1);
    }
    #captcha{
      margin-bottom: 30px;
    }
    .btn-primary{
      display: block;
      width: 100%;
      height: 48px;
      line-height: 48px;
      text-align: center;
      margin-top: 10px;
      cursor: pointer;
      font-size: 18px;
      border-radius: 48px;
    }
  }
  .login-head{
    height: 54px;
    margin-bottom: 30px;
    .tab-hd{
      min-height: 54px;
      text-align: center;
      float: left;
      li{
        display: inline-block;
        margin-right: 36px;
        height: 54px;
        cursor: pointer;
        color: #333;
        font-size: 24px;
        font-weight: bold;
        line-height: 54px;
        &:after{
          content: '';
          position: relative;
          width: 0px;
          height: 4px;
          border-radius: 2px;
          bottom: 0;
          background-color: #f75959;
          display: block;
          margin: 0 auto;
          transition: all 120ms ease-in-out;
        }
        &.on{
          color: #f75959;
        }
        &.on:after{
          width: 80px;
        }
        &:last-child{
          margin-right: 0;
        }
      }
    }
    .btn-reg{
      color: #f75959;
      font-size: 14px;
      line-height: 24px;
      float: right;
      cursor: pointer;
      margin-top: 15px;
      margin-right: -10px;
    }
  }
  .form{
    // overflow: hidden;
    .form-item{
      margin-bottom: 30px;
      overflow: hidden;
      position: relative;
      &:last-child{
        margin-bottom: 0;
      }
      &.code-item{
        .input{
          padding-right: 110px;
        }
      }
    }
    .input{
      width: 100%;
      height: 48px;
      padding: 8px 15px;
      border: 1px solid #999;
      font-size: 18px;
      color: #333;
      line-height: 30px;
      border-radius: 30px;
      &:focus{
        border-color: #f75959;
      }
    }
    .btn-code{
      position: absolute;
      right: 4px;
      top: 4px;
      width: 120px;
      height: 40px;
      background-color: #ddd;
      font-size: 18px;
      color: #999;
      line-height: 40px;
      border-radius: 24px;
      &:disabled{
        background-color: #ddd;
        color: #999;
      }
    }
  }
  .form-foot{
    overflow: hidden;
    padding: 10px 15px;
    .el-checkbox{
      line-height: 24px;
      .is-focus{
        .el-checkbox__inner{
          border-color: #f75959;
        }
      }
      &.is-checked{
        .el-checkbox__inner{
          background-color: #f75959;
          border-color: #f75959;
        }
        .el-checkbox__label{
          color: inherit;
        }
      }
    }
    .btn-forget{
      color: #f75959;
      font-size: 14px;
      line-height: 24px;
      float: right;
      cursor: pointer;
      &:hover{
        text-decoration: underline;
      }
    }
  }
  .btn-group{
    overflow: hidden;
    margin-top: 50px;
    border-top: 1px solid #e5e5e5;
    padding-top: 10px;
    .btn-text{
      float: right;
      font-size: 14px;
      color: #333;
      line-height: 24px;
      margin-right: 10px;
      cursor: pointer;
      &:hover{
        color: #f75959;
      }
    }
    .btn-type{
      float: left;
      font-size: 14px;
      color: #f75959;
      line-height: 24px;
      cursor: pointer;
      &:hover{
        text-decoration: underline;
      }
    }
  }
  #footer{
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 40px;
    text-align: center;
    span{
      color: #333;
    }
    a{
      color: #333;
    }
  }
}


</style>